import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    className={props.className}
  >
    <defs>
      <path
        fill={props.color}
        id="a"
        d="M13.333 6.545H9.167a.826.826 0 0 1-.834-.818v-4.09H2.5a.826.826 0 0 0-.833.818v13.09c0 .452.373.819.833.819h10c.46 0 .833-.367.833-.819v-9h.834c.46 0 .833-.366.833-.818v9.818C15 16.901 13.88 18 12.5 18h-10C1.12 18 0 16.901 0 15.545V2.455C0 1.099 1.12 0 2.5 0h6.667c.22 0 .433.086.589.24l5 4.909c.078.076.14.167.18.265zM10 2.793V4.91h2.155L10 2.793zM10.833 9c.46 0 .834.366.834.818a.826.826 0 0 1-.834.818H4.167a.826.826 0 0 1-.834-.818c0-.452.373-.818.834-.818h6.666zm0 3.273c.46 0 .834.366.834.818a.826.826 0 0 1-.834.818H4.167a.826.826 0 0 1-.834-.818c0-.452.373-.818.834-.818h6.666zm-5-6.546c.46 0 .834.367.834.818a.826.826 0 0 1-.834.819H4.167a.826.826 0 0 1-.834-.819c0-.451.373-.818.834-.818h1.666z"
      />
    </defs>
    <use fill={props.color} fillRule="nonzero" xlinkHref="#a" />
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

SVG.defaultProps = {
  color: '#4186EF',
};

export default SVG;
